import React, { useEffect, useState } from 'react';
import { Col, Row, Input, Button, Modal } from 'antd';
import PhoneInput from 'react-phone-number-input';
import Country from 'react-phone-number-input/locale/en';
import { Color } from 'services';
import { Heading, SubHeading } from 'components/Typography';


export const contactInfo = (kycDetails, handleUpdateDetails, verifiedOtpforRegistration, setVerfiyOtpModal, postMobileNumberForRegistration, verfiyOtpModal, otpKey, verifyOtpLoader, postVerifyOtpForRegistration, resendOtpTimer, sendOtpLoader, timer, verifiedOtpForRegistrationAction, organisationDetails) => {

    const [otp, setOtp] = useState('');
    const [isOtpVerified, setIsOtpVerified] = useState(false);
    const [existingPhoneNum, setExistingPhoneNum] = useState(kycDetails?.contactPhone)
    const [isPhoneChanged, setIsPhoneChanged] = useState(false);
    const [phoneError, setPhoneError] = useState("");
    const [isOtpFocused, setIsOtpFocused] = useState(false);

    const validatePhone = (phone, rawVal) => {
        if (!phone || phone === "") return "";
        if (rawVal) {
            const cleanRaw = rawVal.replace(/[^0-9]/g, '');
            if (cleanRaw.startsWith('0')) {
                return "Phone number cannot start with 0";
            }
        }
        const clean = String(phone).replace(/[^0-9]/g, '');
        let nationalNumber = clean;
        if (clean.startsWith('91')) {
            nationalNumber = clean.substring(2);
        }
        if (!nationalNumber || nationalNumber === "") {
            return "";
        }
        if (nationalNumber.length > 0) {
            const firstDigit = nationalNumber.charAt(0);
            if (firstDigit === '0') {
                return "Phone number cannot start with 0";
            }
            if (firstDigit < '6' || firstDigit > '9') {
                return "Phone number must start with 6, 7, 8, or 9";
            }
        }
        if (nationalNumber.length !== 10) {
            return "Phone number must be exactly 10 digits";
        }
        return "";
    }

    useEffect(() => {
        let rawVal = "";
        if (document.activeElement && (document.activeElement.tagName === 'INPUT' || document.activeElement.tagName === 'TEXTAREA')) {
            rawVal = document.activeElement.value;
        }
        if (kycDetails?.contactPhone) {
            setPhoneError(validatePhone(kycDetails.contactPhone, rawVal));
        } else {
            setPhoneError("");
        }
    }, [kycDetails?.contactPhone]);

    function sendOtpForRegistration(phone) {
        const number = phone.replace(/-/g, "").replace(/ /g, "");
        postMobileNumberForRegistration(number, "");
    }
    useEffect(() => {
        const savedPhone = (organisationDetails?.contactPhone || '').trim();
        const currentPhone = (kycDetails?.contactPhone || '').trim();

        if (isPhoneChanged && savedPhone !== currentPhone) {
            setIsOtpVerified(true);
            verifiedOtpForRegistrationAction(false);
        } else {
            setIsOtpVerified(false);
            if (savedPhone && currentPhone === savedPhone) {
                verifiedOtpForRegistrationAction(true);
            }
        }
    }, [kycDetails?.contactPhone, organisationDetails?.contactPhone, isPhoneChanged]);
    const validateEmail = (email) => {
        const re =
            /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
        return re.test(String(email).toLowerCase());
    };

    return (
        <>
            <div style={{ width: "100%" }}>
                <Row className="m-t-20">
                    <Col xs={{ span: 24 }} md={{ span: 12, offset: 0 }}>
                        <div className='text-xs color-black m-b-5 bold-600' >Name <span style={{ color: Color.red }}>*</span></div>
                        <Input onChange={(e) => handleUpdateDetails(e.target.value.replace(/[^a-zA-Z ]/g, ''), 'contactName')}
                            value={kycDetails?.contactName} placeholder="Enter Name of the contact person"
                            className='radius-5 kyc-input-fields'
                            style={{ background: Color.lightGrey, border: 'none' }}
                            disabled={kycDetails?.kycStatus === "Submitted" || kycDetails?.kycStatus === "Approved"}
                        />
                    </Col>
                    <Col xs={{ span: 24, }} md={{ span: 11, offset: 1 }} style={{ width: '100%' }} >
                        <div className='text-xs color-black m-b-5 bold-600' >Phone <span style={{ color: Color.red }}>*</span> </div>
                        <div className="r-c-sb phone-input-wrapper" style={{ padding: '0px 0px 0px 10px', position: 'relative' }}>
                            <PhoneInput
                                style={{ width: '100%', height: "60px", minWidth: '100px', maxWidth: '100%' }}
                                className='contact-phone-input'
                                defaultCountry="IN"
                                placeholder="Enter Phone Number"
                                suffix={"abc"}
                                value={kycDetails?.contactPhone}
                                onCountryChange={(e) => {
                                    console.log('code', Country[e]);
                                }}
                                maxLength={(kycDetails?.contactPhone?.startsWith('+91') || kycDetails?.contactPhone?.startsWith('91')) && kycDetails?.contactPhone?.length == 13 ? 11 : ""}
                                disabled={kycDetails.kycStatus === "Submitted" || kycDetails.kycStatus === "Approved"}
                                onChange={(e) => {
                                    let val = e;
                                    let rawVal = "";
                                    if (document.activeElement && (document.activeElement.tagName === 'INPUT' || document.activeElement.tagName === 'TEXTAREA')) {
                                        rawVal = document.activeElement.value;
                                    }

                                    const cleanRaw = rawVal.replace(/[^0-9]/g, '');
                                    if (cleanRaw.startsWith('0') || cleanRaw.startsWith('910')) {
                                        const startsWith91 = cleanRaw.startsWith('91');
                                        const national = startsWith91 ? cleanRaw.substring(2) : cleanRaw;
                                        if (national.length > 10) {
                                            const truncatedNational = national.substring(0, 10);
                                            val = startsWith91 ? `+91${truncatedNational}` : truncatedNational;
                                            if (document.activeElement) {
                                                document.activeElement.value = startsWith91 ? `+91 ${truncatedNational.substring(0, 5)} ${truncatedNational.substring(5)}` : truncatedNational;
                                            }
                                        }
                                    } else {
                                        if (val && val.startsWith('+91') && val.length > 13) {
                                            val = val.slice(0, 13);
                                        }
                                    }

                                    handleUpdateDetails(val, 'contactPhone');
                                    setIsPhoneChanged(true);
                                }}
                            />
                            {
                                isOtpVerified ?
                                    <>
                                        {
                                            verifiedOtpforRegistration
                                                ? <Button onClick={() => {
                                                    //Nothing
                                                }} type="text" className="bold-bold"
                                                    style={{
                                                        color: "#28DF99",
                                                        backgroundColor: 'transparent',
                                                        position: 'absolute',
                                                        right: '15px',
                                                        top: '50%',
                                                        transform: 'translateY(-50%)',
                                                        zIndex: 10,
                                                    }} >
                                                    Verified
                                                </Button>
                                                : <Button onClick={() => {
                                                    sendOtpForRegistration(kycDetails?.contactPhone);
                                                    setVerfiyOtpModal(true);
                                                    setOtp("")
                                                }} type="text" className="bold-bold"
                                                    disabled={!!phoneError || !kycDetails?.contactPhone || (kycDetails?.contactPhone?.length > 12 && kycDetails?.contactPhone?.length <= 17 ? false : true)}
                                                    style={{
                                                        color: "#1089FF",
                                                        backgroundColor: 'transparent',
                                                        position: 'absolute',
                                                        right: '15px',
                                                        top: '50%',
                                                        transform: 'translateY(-50%)',
                                                        zIndex: 10,
                                                        opacity: (phoneError || !kycDetails?.contactPhone || (kycDetails?.contactPhone?.length > 12 && kycDetails?.contactPhone?.length <= 17 ? false : true)) ? 0.5 : 1.0,
                                                    }} >
                                                    SEND OTP
                                                </Button>
                                        }
                                    </>
                                    :
                                    null
                            }
                        </div>
                        {phoneError && (
                            <div style={{ color: "red", fontSize: "12px", marginTop: "5px", marginBottom: "5px" }}>
                                {phoneError}
                            </div>
                        )}
                    </Col>
                </Row>
                <Row className="m-t-20">
                    <Col xs={{ span: 24 }} md={{ span: 12, offset: 0 }}>
                        <div className='text-xs color-black m-b-5 bold-600' >Email <span style={{ color: Color.red }}>*</span></div>
                        <Input onChange={(e) => handleUpdateDetails(e.target.value, 'contactEmail')}
                            value={kycDetails?.contactEmail} placeholder="Enter Email ID"
                            className='radius-5 kyc-input-fields' style={{ background: Color.lightGrey, border: 'none' }}
                            disabled={kycDetails?.kycStatus === "Submitted" || kycDetails?.kycStatus === "Approved"}
                        />
                        {
                            kycDetails.contactEmail &&
                            !kycDetails.emailValid && (
                                <div
                                    style={{
                                        color: '#ff4d4f',
                                        fontSize: '12px',
                                        marginTop: '4px'
                                    }}
                                >
                                    Enter valid email id
                                </div>
                            )
                        }
                    </Col>
                    <Col xs={{ span: 24, }} md={{ span: 11, offset: 1 }} style={{ width: '100%' }} >
                        {/* <div className="display-flex">        
                    <div className='text-xs color-black m-b-5 bold-600' >Alternate Email <span style={{color:Color.red}}>*</span></div>
                    <Tooltip title="In case a student does not provide an email, all payment related communications will be sent to this email.">
                        <InfoCircleOutlined style={{marginLeft: 10, color: Color.darkGrey}} />
                    </Tooltip>
                </div>    
                <Input onChange={(e) => handleUpdateDetails(e.target.value, 'alternateEmail')}
                value={kycDetails.contactEmail} placeholder="Alternate Email ID" className='radius-5 kyc-input-fields' style={{background:Color.lightGrey, border:'none'}}/> */}

                    </Col>
                </Row>
            </div>
            <Modal
                centered
                closable={true}
                footer={null}
                transitionName=""
                maskClosable={true}
                visible={verfiyOtpModal}
                className="verifyOtpModal kycVerifyOtpModal"
                onCancel={() => {
                    setOtp("");
                    setVerfiyOtpModal(false);
                }}
            >
                <Heading bold className='r-c-c m-t-10'>Verify Your Number</Heading>
                <SubHeading color="#636363" className='r-c-c m-t-10'>We’ve sent a verification code to</SubHeading>

                <div className='r-c-c m-t-5'>
                    <SubHeading bold color="#636363">{kycDetails?.contactPhone}</SubHeading>
                    <Button onClick={() => {
                        setOtp("");
                        setVerfiyOtpModal(false);
                    }} type="text" className="bold-bold"
                        style={{ color: '#1089FF' }} >
                        Edit
                    </Button>
                </div>

                <div style={{ position: "relative" }} className="r-c-c m-t-30">
                    <div className="r-c-c" style={{ fontWeight: 700 }}>
                        <div className="otpInputNew">{otp[0] ? "*" : (isOtpFocused && otp.length === 0 ? <span className="blinking-cursor">|</span> : null)}</div>
                        <div className="otpInputNew">{otp[1] ? "*" : (isOtpFocused && otp.length === 1 ? <span className="blinking-cursor">|</span> : null)}</div>
                        <div className="otpInputNew">{otp[2] ? "*" : (isOtpFocused && otp.length === 2 ? <span className="blinking-cursor">|</span> : null)}</div>
                        <div className="otpInputNew">{otp[3] ? "*" : (isOtpFocused && otp.length === 3 ? <span className="blinking-cursor">|</span> : null)}</div>
                        <div className="otpInputNew">{otp[4] ? "*" : (isOtpFocused && otp.length === 4 ? <span className="blinking-cursor">|</span> : null)}</div>
                        <div className="otpInputNew">{otp[5] ? "*" : (isOtpFocused && otp.length === 5 ? <span className="blinking-cursor">|</span> : null)}</div>
                    </div>
                    <input type="number" className='aulas-login__input-verify-otp'
                        value={otp}
                        onChange={(em) => setOtp(em.target.value.substring(0, 6))}
                        onFocus={() => setIsOtpFocused(true)}
                        onBlur={() => setIsOtpFocused(false)}
                    />
                </div>
                <div style={{ marginTop: 30, display: 'flex', justifyContent: 'center' }}>
                    <Button type="primary" shape="round" className="r-c-c bold-bold" style={{ width: '200px', height: '40px' }}
                        onClick={() => postVerifyOtpForRegistration(kycDetails?.contactPhone, otp)} loading={verifyOtpLoader}
                        disabled={!otp || otp.length < 6}
                    >
                        VERIFY
                    </Button>
                </div>

                <div className='r-c-c m-t-20' style={{ gap: '10px' }}>
                    <SubHeading color="#636363" style={{ marginBottom: 0 }}>Didn’t receive a code?</SubHeading>
                    <Button type="text"
                        className="bold-bold"
                        style={{ color: !resendOtpTimer ? '#1089FF' : '#28DF99', padding: 0, height: 'auto' }}
                        onClick={() => {
                            sendOtpForRegistration(kycDetails?.contactPhone);
                        }}
                        loading={sendOtpLoader}
                        disabled={verifyOtpLoader || resendOtpTimer}
                    >
                        Resend OTP {timer == '' ? '' : `in ${timer}`}
                    </Button>
                </div>
            </Modal>
        </>
    )
}

